import * as React from "react";

import {
  Box,
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Button,
} from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DiscardPopup({ open, handleClose }) {
  return (
    <Box color="default">
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "white",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 16,
            padding: 16,
          },
        }}
      >
        <DialogContent>
          <DialogContentText
            color="secondary"
            align="center"
            id="alert-dialog-slide-description"
          >
            Do you want to save the changes?
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Button
            style={{ width: "50%", padding: "10px 45px !important" }}
            variant="contained"
            sx={{ backgroundColor: "#E5E5E5" }}
            onClick={() => handleClose(false)}
          >
            Discard
          </Button>
          <Button
            style={{ width: "50%", padding: "10px 45px !important" }}
            variant="outlined"
            color="secondary"
            onClick={() => handleClose(true)}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
